/**
 * A dataservice that provides operations for tap events
 */
export class TapService {
  private resource: InterACT.Interfaces.IResource<InterACT.Interfaces.TfnTaps.TfnTapResponse>;

  constructor(private $resource: ng.resource.IResourceService) {
    this.resource = $resource('api/tfn-taps/:tapEventId');
  }

  /**
   * Function to create a Tap Event
   *
   * @param tapEvent An object representation of a tap event
   * @returns A promise that resolves when the create operation is completed
   */
  public create(tapEvent: InterACT.Interfaces.TfnTaps.TfnTap) {
    return this.resource.save(tapEvent).$promise;
  }

  /**
 * Retrieves a single tap event using the supplied id
 * @param id the id of the tap event to retrieve
 * @return a promise that resolves with the tap event when the operation is complete
 */
  public get(id: string): ng.IPromise<InterACT.Interfaces.TfnTaps.TfnTapResponse> {
    return this.resource.get({ tapEventId: id }).$promise;
  }
}
